import { AddressBookContextState } from './address-book-context-types';

export const initialAddressBookState: AddressBookContextState = {
  isBulkUploadDialogOpen: false,
  isValidationModalOpen: false,
  addressesWithErrors: {
    error_count: 0,
    success_count: 0,
    duplicate_count: 0,
    duplicate_count_in_file: 0,
    contacts: [],
  },
  currentAddressIndex: 0,
  isTooManyErrorsDialogOpen: false,
  isSkipAllErrorsDialogOpen: false,
};
